























































import { Vue, Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { Organization, OrganizationType } from '@models';

@Component
export default class TreeItem extends Vue {
  name = 'tree-item';
  @Prop(Object) readonly organization!: Organization;
  orgType = OrganizationType;

  editUsersClick(org: Organization) {
    document.dispatchEvent(new CustomEvent('edituserclick', { detail: { 'org': org } }));
  }

  addOrganizationClick(org: Organization) {
    document.dispatchEvent(new CustomEvent('addorgclick', { detail: { 'org': org } }));
  }

  deleteOrganization(org: Organization) {
    document.dispatchEvent(new CustomEvent('deleteorgclick', { detail: { 'org': org } }));
  }

  editOrganizationClick(org: Organization) {
    document.dispatchEvent(new CustomEvent('editorgclick', { detail: { 'org': org } }));
  }

  nodeClicked = (event) => {
    var cells = document.querySelectorAll('.orgCell');
    for (var i = 0; i < cells.length; i++) {
      cells[i].parentElement.classList.remove('orgNodeSelected');
    }

    const element = event.target;
    element.parentElement.classList.add('orgNodeSelected');
  }
}
